export function carousels() {
	// constructor() {
	$(".post-carousel").each(function () {
		var scopeThis = $(this);
		var randAttribute = Math.floor(Math.random() * 10000);
		$(this).addClass("cardpaged-" + randAttribute);
		$(this).addClass("f-init");
		var countCycleItems = $(this).find(".post-single").length;

		var groupCells = 3;
		groupCells = false;
		var autoH = false;
		if ($(window).width() < 768) {
			groupCells = false;
			autoH = true;
		}

		if (countCycleItems > 3) {
			var slider = $(".cardpaged-" + randAttribute)
				.flickity({
					wrapAround: false,
					cellAlign: "left",
					cellSelector: ".post-single",
					groupCells: groupCells,
					prevNextButtons: true,
					pageDots: false,
					adaptiveHeight: autoH,
				})
				.on("change.flickity", function (event, index) {
					var flickData = $(".cardpaged-" + randAttribute).data(
						"flickity"
					);
					$(".cardpaged-" + randAttribute)
						.find(".cycle-curr")
						.html(flickData.selectedIndex + 1);
					$(".cardpaged-" + randAttribute)
						.find(".cycle-total")
						.html(flickData.slides.length);
				});

			var flickData = $(".cardpaged-" + randAttribute).data("flickity");
			$(".cardpaged-" + randAttribute)
				.find(".cycle-curr")
				.html(flickData.selectedIndex + 1);
			$(".cardpaged-" + randAttribute)
				.find(".cycle-total")
				.html(flickData.slides.length);

			$(".cardpaged-" + randAttribute)
				.find(".cycle-previous")
				.on("click", function () {
					$(".cardpaged-" + randAttribute).flickity("previous");
				});
			$(".cardpaged-" + randAttribute)
				.find(".cycle-next")
				.on("click", function () {
					// instance.next();
					$(".cardpaged-" + randAttribute).flickity("next");
				});
		}
	});
	// }
}
